import React from "react";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";

//Import Images
import AboutImage from "../../../assets/images/about/img-01.jpg";

const About = () => {
    return (
        <React.Fragment>
            <section className="section overflow-hidden">
                <Container>
                    <Row className="align-items-center g-0">
                        <Col lg={7}>
                            <div className="section-title me-lg-5">
                                <h6 className="sub-title">About Matrix Executive Search Group</h6>
                                <h2 className="title mb-4">
                                    What <span className="text-warning fw-bold">  We</span>{" "} Do
                                </h2>
                                <p className="text-muted">
                                    At Matrix Executive Search Group, we connect exceptional talent with outstanding
                                    companies—specializing in the Corrugated Packaging, Paper Mills, and Food &amp; Beverage
                                    industries, while also successfully serving clients across multiple other sectors. Our mission is
                                    to bring clarity, commitment, and excellence to the recruitment process—whether you&#39;re an
                                    organization seeking top-tier talent or a professional pursuing your next career opportunity.
                                </p>

                                <Row className="mt-4 pt-2">
                                    <Col md={12}>
                                        <ul className="list-unstyled about-list text-muted mb-0 mb-md-3">
                                            <li> Fast and user-friendly job search experience.</li>
                                            <li> Verified and quality job postings only.</li>
                                            <li> Real-time job alerts tailored to your profile.</li>
                                            <li> Secure and private candidate profiles.</li>
                                            <li> Dedicated customer support for users.</li>
                                            <li> Smart filtering to match jobs more accurately.</li>
                                            <li> Thousands of successful job placements.</li>
                                        </ul>
                                    </Col>
                                    {/* <Col md={6}>
                                        <ul className="list-unstyled about-list text-muted">
                                            <li> Create Resume</li>
                                            <li> 5000+ Comnpanies</li>
                                            <li> Our Blog</li>
                                            <li> and more...</li>
                                        </ul>
                                    </Col> */}
                                </Row>
                                <div className="mt-3">
                                    <Link to="/contact-us" className="btn btn-primary btn-hover">
                                        Contact Us
                                        {" "}
                                        <i className="uil uil-angle-right-b align-middle"></i>
                                    </Link>
                                </div>
                            </div>
                        </Col>
                        <Col lg={5}>
                            <div className="about-img mt-4 mt-lg-0" style={{ width: '100%' }}>
                                <img src={AboutImage} alt="" className="img-fluid rounded" style={{ width: '100%', height: '600px', objectFit: 'cover' }} draggable={false} />
                            </div>
                        </Col>
                    </Row>
                    <Row className="mt-4 align-items-center g-5">
                        <Col lg={5}>
                            <div className="about-img mt-4 mt-lg-0" style={{ width: '100%' }}>
                                <img src={AboutImage} alt="" className="img-fluid rounded" style={{ width: '100%', height: '900px', objectFit: 'cover' }} draggable={false} />
                            </div>
                        </Col>
                        <Col lg={7}>
                            <div className="section-title me-lg-5">
                                <h6 className="sub-title">About Matrix Executive Search Group</h6>
                                <h2 className="title mb-4">
                                    Specialized Recruiting That Delivers <span className="text-warning fw-bold">  Results</span>{" "}
                                </h2>
                                <p className="text-muted">
                                    Matrix is more than a recruiting firm—we are strategic partners in talent acquisition. Our
                                    seasoned specialists bring deep industry expertise and a proven ability to identify candidates who
                                    align with your technical requirements, company culture, and long-term vision.
                                </p>
                                <p className="text-muted">We utilize cutting-edge search technology and a deeply personalized approach to connect
                                    companies with both passive and active job seekers—those who are currently employed and not
                                    actively looking, as well as highly motivated professionals ready for their next opportunity.</p>

                                <Row className="mt-4 pt-2">
                                    <Col md={12}>
                                        <p className="mb--5">Our recruiting specialties include:</p>
                                        <ul className="list-unstyled about-list text-muted mb-0 mb-md-3">
                                            <li> Executive Leadership.</li>
                                            <li> Sales &amp; Marketing.</li>
                                            <li> General Management.</li>
                                            <li> Supervisors &amp; Operations Leaders.</li>
                                            <li> Human Resources.</li>
                                            <li> Accounting &amp; Finance.</li>
                                            <li> Logistics &amp; Supply Chain.</li>
                                            <li> Maintenance Managers &amp; Techs.</li>
                                            <li> Engineering.</li>
                                            <li> Specialized Hourly Roles.</li>
                                        </ul>
                                    </Col>
                                    <p className="text-muted">From C-suite executives to skilled hourly personnel, we consistently deliver talent that makes an
                                        immediate and lasting impact.</p>
                                    {/* <Col md={6}>
                                        <ul className="list-unstyled about-list text-muted">
                                            <li> Create Resume</li>
                                            <li> 5000+ Comnpanies</li>
                                            <li> Our Blog</li>
                                            <li> and more...</li>
                                        </ul>
                                    </Col> */}
                                </Row>
                                <div className="mt-3">
                                    <Link to="/contact-us" className="btn btn-primary btn-hover">
                                        Contact Us
                                        {" "}
                                        <i className="uil uil-angle-right-b align-middle"></i>
                                    </Link>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default About;
